module.exports = __webpack_public_path__ + "media/vid.77a5394f.mp4";